import { Table } from "react-bootstrap";
import { ShrinkHeader } from "../../../Table/ShrinkHeader";
import { LayerImportStateMap } from "../../../../constant/LayerImportState";
import { useContext } from "react";
import LoadingSpinner from "../../../Loading/LoadingSpinner";
import TableFooter from "../../../Table/Footer";
import { LayerContext } from "../LayerContext";
import { TableContainer } from "../../../../@ui/TableContainer";
import TableActionButton from "../../../../@ui/TableActionButton";
import { useNavigate } from "react-router-dom";

const ImportTable = () => {
  const value = useContext(LayerContext);
  const { setImportPage, layerInfo, importsLoading } = value!;
  const tableModel = layerInfo.imports;
  const loading = importsLoading;
  const navigate = useNavigate();

  const viewImport = (importItem: any) => {
    navigate(
      `/admin/layers/${layerInfo.layerName}/logs?importId=${
        importItem.importId
      }&start=${importItem.started.toSeconds()}`,
    );
  };

  return (
    <>
      <TableContainer>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th className="p-2 text-white bg-primary">Source Name</th>
              <th className="p-2 text-white bg-primary">Started</th>
              <th className="p-2 text-white bg-primary">Completed</th>
              <th className="p-2 text-white bg-primary">State</th>
              <th className="p-2 text-white bg-primary">Total Records</th>
              {tableModel?.records?.length > 0 && !importsLoading && (
                <ShrinkHeader className="p-2 text-white bg-primary"></ShrinkHeader>
              )}
            </tr>
          </thead>
          <tbody>
            {!importsLoading &&
              tableModel?.records?.map((importItem) => (
                <tr key={importItem.importId}>
                  <td>{importItem.sourceName}</td>
                  <td>{importItem.started.toFormat("dd/MM/yyyy HH:mm:ss")}</td>
                  <td>
                    {importItem.completed
                      ? importItem.completed.toFormat("dd/MM/yyyy HH:mm:ss")
                      : "-"}
                  </td>
                  <td>{LayerImportStateMap.get(importItem.state)}</td>
                  <td>{importItem.totalRecords}</td>
                  <td className="text-center">
                    <TableActionButton onClick={() => viewImport(importItem)}>
                      Logs
                    </TableActionButton>
                  </td>
                </tr>
              ))}
            {tableModel.records &&
              tableModel.records.length === 0 &&
              !loading && (
                <tr>
                  <td colSpan={6} className="text-center">
                    No imports found
                  </td>
                </tr>
              )}
            {loading && (
              <tr>
                <td colSpan={6} className="text-center">
                  <LoadingSpinner />
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </TableContainer>
      <TableFooter
        currentPage={tableModel.page}
        setCurrentPage={setImportPage}
        totalItems={tableModel.totalPages * 25}
        pageSize={25}
      />
    </>
  );
};

export default ImportTable;
